// import { Visitor } from "@firefly/fly-painter-util/es/node";
import clone from "lodash/clone";
import { Documents } from "@firefly/fly-design-core";
// import { Document, Element } from "../typing/doc";
// import {
//   Documents,
//   isElementDocument,
//   isImageDocument,
//   isMaternalDocument,
//   isPageDocument,
// } from "../util/document";
import { upgradeAnimation } from "./upgrade0";
export var upgradePageElementVisitor = {
  element: {
    enter: function enter(element) {
      var as = element.as,
        properties = element.properties;
      delete properties._zIndex;
      if (as === "ClipPathImage") {
        element.as = "ClippathImage";
      }
      if (properties.animations) {
        var animations = properties.animations.map(function (animation) {
          var type = animation.type,
            name = animation.name,
            args = animation.args;
          var output = upgradeAnimation(animation);
          if (!output) {
            console.error("upgrade animation[".concat(type, " ").concat(name, " ").concat(args, "] failure"));
          }
          return output;
        }).filter(function (item) {
          return !!item;
        });
        element.properties.animations = animations;
      }
    }
  }
};
export default function upgrade1(input) {
  var upgradeClippathVisitor = {
    element: {
      enter: function enter(element) {
        var as = element.as,
          properties = element.properties;
        delete properties._zIndex;
        delete properties.identifier;
        if (as === "ClipPathImage") {
          element.as = "ClippathImage";
        }
      }
    }
  };
  var document = clone(input);
  if (Documents.isPageDocument(document)) {
    // if (!isPageLayoutDocument(document)) {
    // const { envelope } = document;
    // if (envelope) {
    //   Elements.visit(envelope.elements, upgradePageElementVisitor);
    // }
    // }
    delete document.envelope;
    Documents.visitElement(document, upgradePageElementVisitor);
    document.version = "1.1";
  } else if (Documents.isImageDocument(document)) {
    Documents.visitElement(document, upgradeClippathVisitor);
    document.version = "1.1";
  } else if (Documents.isElementDocument(document)) {
    Documents.visitElement(document, upgradeClippathVisitor);
    document.version = "1.1";
  } else if (Documents.isMaternalDocument(document)) {
    Documents.visitElement(document, upgradeClippathVisitor);
    document.version = "1.1";
  }
  return document;
}